import React, { useEffect, useState } from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';

import {
  Container,
  Typography,
  Box,
  CircularProgress,
  Button,
  TextField,
  Grid,
  IconButton,
  Modal,
  Box as MuiBox,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const Events = () => {
  const token = localStorage.getItem('token');
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  const [isAdmin, setIsAdmin] = useState(true); // Assuming admin status is handled
  const [editingEvent, setEditingEvent] = useState(null);
  const [open, setOpen] = useState(false); // Modal state for Add/Edit
  const [eventForm, setEventForm] = useState({ // Form data
    eventDate: '',
    description: '',
    venue: '',
    link:'',
    startTime: '',
    endTime: '',
    status: '',
    whoCanApply: '', // NEW FIELD
  });

  useEffect(() => {
    // Fetching upcoming events
    fetchevents()
  }, []);

  const fetchevents= () => {
      setLoading(true);
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/events`)
        .then(res => { 
          setEvents(res.data);
        })
        .catch(err => console.error('Error fetching events', err))
        .finally(() => setLoading(false));
    };
  

  const handleDeleteEvent = (id) => {
    axios
      .delete(`${process.env.REACT_APP_API_BASE_URL}/api/events/${id}`)
      .then(() => {
        setEvents(events.filter((event) => event.id !== id));
      })
      .catch((err) => console.error('Error deleting event', err));
  };

  const handleEditEvent = (event) => {
    const formattedDate = new Date(event.eventDate).toISOString().split('T')[0]; // "YYYY-MM-DD"
    setEditingEvent(event);
    setEventForm({
      ...event,
      eventDate: formattedDate,
      startTime: event.startTime || '',
      endTime: event.endTime || '',
      status:event.status || '',
      whoCanApply:event.whoCanApply || ''
    });
    setOpen(true);
  };
  

  const handleAddEvent = () => {
    setEditingEvent(null); // Clear any selected event
    setEventForm({ eventDate: '', description: '', venue: '',startTime:'',endTime:'',status:'',whoCanApply:'' });
    setOpen(true);
  };

  const handleFormSubmit = () => {
    const { eventDate, description, venue,startTime, endTime,status,whoCanApply} = eventForm;
  
    if (!eventDate || !startTime || !endTime || !description || !venue || !status || !whoCanApply) {
      alert('All fields including Start Time and End Time are mandatory.');
      return;
    }
  
    if (editingEvent) {
      // Update event
      const updatedEvent = {
        ...eventForm
      };
  
      axios
        .put(`${process.env.REACT_APP_API_BASE_URL}/api/events/${editingEvent.id}`, updatedEvent,{
            headers: { Authorization: `Bearer ${token}` }
          })
        .then((res) => {
            if(res){
                alert('Event Updated successfully!');
                setOpen(false)
                fetchevents()
            }
        })
        .catch((err) => console.error('Error updating event', err));
    } else {
      // Add new event
      const newEvent = {
        ...eventForm 
      };
  
      axios
        .post(`${process.env.REACT_APP_API_BASE_URL}/api/events`, newEvent,{
            headers: { Authorization: `Bearer ${token}` }
          })
        
        .then((res) => {
            if(res){
                alert('Event Added successfully!');
                setOpen(false)
                fetchevents()
            }
        })
        .catch((err) => console.error('Error adding event', err));
    }
  };
  
  const filteredEvents = events.filter((event) => {
    return (
      event.description.toLowerCase().includes(filter.toLowerCase()) ||
      event.venue.toLowerCase().includes(filter.toLowerCase())
    );
  });

  const columns = [
    { field: 'eventDate', headerName: 'Event Date', width: 180,
        renderCell: (params) => {
            const rawDate = params.value;
            const date = new Date(rawDate);
        
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0'); 
            return `${year}-${month}-${day}`;
          },
     },
    { field: 'startTime', headerName: 'Start Time', width: 120 },
    { field: 'endTime', headerName: 'End Time', width: 120 },
    { field: 'description', headerName: 'Event Description', width: 400 },
    { field: 'venue', headerName: 'Venue', width: 250 },
    {
      field: 'link',
      headerName: 'Registration Link',
      width: 250,
      renderCell: (params) => (
        <a
          href={params.value}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#1976d2', textDecoration: 'underline' }}
        >
          {params.value}
        </a>
      ),
    },

    { field: 'status', headerName: 'Status', width: 120 },
    { field: 'whoCanApply', headerName: 'Eligible', width: 150 },
    ...(isAdmin
      ? [
          {
            field: 'actions',
            headerName: 'Actions',
            width: 150,
            renderCell: (params) => (
              <>
                <IconButton
                  onClick={() => handleEditEvent(params.row)}
                  color="primary"
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  onClick={() => handleDeleteEvent(params.row.id)}
                  color="secondary"
                >
                  <DeleteIcon />
                </IconButton>
              </>
            ),
          },
        ]
      : []),
  ];

  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Upcoming Events
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <TextField
                label="Search by description or venue"
                variant="outlined"
                fullWidth
                onChange={(e) => setFilter(e.target.value)}
                sx={{ flexGrow: 1, mr: 2 }}
            />
            <IconButton
                color="primary"
                onClick={() => {
                setLoading(true);
                axios
                    .get(`${process.env.REACT_APP_API_BASE_URL}/api/events`)
                    .then((res) => setEvents(res.data))
                    .catch((err) => console.error('Error refreshing events', err))
                    .finally(() => setLoading(false));
                }}
                title="Refresh"
            >
                <RefreshIcon />
            </IconButton>
        </Box>



      {loading ? (
        <CircularProgress />
      ) : (
        <>
          <Box sx={{ mb: 2 }}>
            {isAdmin && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={handleAddEvent}
              >
                Add Event
              </Button>
            )}
          </Box>

          <div style={{ height: 400, width: '100%' }}>
            <DataGrid
              rows={filteredEvents}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5]}
              disableSelectionOnClick
            />
          </div>
        </>
      )}

      {/* Modal for Adding/Editing Events */}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="add-edit-event-modal"
        aria-describedby="modal-for-adding-or-editing-events"
      >
        <MuiBox
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" gutterBottom>
            {editingEvent ? 'Edit Event' : 'Add Event'}
          </Typography>

          <TextField
            label="Event Date"
            variant="outlined"
            fullWidth
            type="date"
            value={eventForm.eventDate}
            onChange={(e) => setEventForm({ ...eventForm, eventDate: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            label="Start Time"
            variant="outlined"
            fullWidth
            type="time"
            value={eventForm.startTime}
            onChange={(e) => setEventForm({ ...eventForm, startTime: e.target.value })}
            sx={{ mb: 2 }}
          />

          <TextField
            label="End Time"
            variant="outlined"
            fullWidth
            type="time"
            value={eventForm.endTime}
            onChange={(e) => setEventForm({ ...eventForm, endTime: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            label="Event Description"
            variant="outlined"
            fullWidth
            value={eventForm.description}
            onChange={(e) => setEventForm({ ...eventForm, description: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            label="Venue"
            variant="outlined"
            fullWidth
            value={eventForm.venue}
            onChange={(e) => setEventForm({ ...eventForm, venue: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            label="Registration Link"
            variant="outlined"
            fullWidth
            value={eventForm.link}
            onChange={(e) => setEventForm({ ...eventForm, link: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            select
            label="Event Status"
            variant="outlined"
            fullWidth
            value={eventForm.status}
            onChange={(e) => setEventForm({ ...eventForm, status: e.target.value })}
            sx={{ mb: 2 }}
            SelectProps={{ native: true }}
          >
            <option value=""></option>
            <option value="open">Open</option>
            <option value="closed">Closed</option>
          </TextField>
          <TextField
            select
            label="Who Can Apply"
            variant="outlined"
            fullWidth
            value={eventForm.whoCanApply}
            onChange={(e) => setEventForm({ ...eventForm, whoCanApply: e.target.value })}
            sx={{ mb: 2 }}
            SelectProps={{ native: true }}
          >
            <option value=""></option>
            <option value="anyone">Anyone</option>
            <option value="member">Members Only</option>
          </TextField>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleFormSubmit}
            >
              {editingEvent ? 'Update Event' : 'Add Event'}
            </Button>
          </Box>
        </MuiBox>
      </Modal>
    </Container>
  );
};

export default Events;
